import { useContext, useMemo } from 'react';
import FavoritesContext from '~/contexts/FavoritesContext';
import InventoryContext from '~/contexts/InventoryContext';
import { type TileData } from '~/contexts/TileDataContext';
import type { ConditionalTile } from '~/contracts';
import useConditionalTiles, {
  injectExperimentConditionalTiles
} from '~/hooks/useConditionalTiles';
import { getDeliveryOrPickupInfo } from '../../ResultTileV2/helpers/ResultTile.helpers';

export default function useExperimentTiles(
  shouldLoad: boolean
): Array<ConditionalTile | TileData> {
  const conditionalTiles = useConditionalTiles();
  const { inventory } = useContext(InventoryContext);
  const { favorites } = useContext(FavoritesContext);

  return useMemo<Array<ConditionalTile | TileData>>(() => {
    if (
      !shouldLoad ||
      !inventory.isLoaded ||
      !inventory.data.inventory.vehicles.length
    ) {
      return [];
    }

    const tileData = inventory.data.inventory.vehicles.map<TileData>(
      vehicle => ({
        ...vehicle,
        isFavorite: favorites.some(v => v.vehicleId === vehicle.vehicleId),
        soonestAvailabilityInfo: getDeliveryOrPickupInfo(vehicle)
      })
    );

    return injectExperimentConditionalTiles(tileData, conditionalTiles);
  }, [
    conditionalTiles,
    favorites,
    inventory.data.inventory.vehicles,
    inventory.isLoaded,
    shouldLoad
  ]);
}
